import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    rootContainer: {
        cursor: 'pointer'
    }
});
export default useStyles;
